// import mobile from "is-mobile";
// const isMobile = mobile();
export * from "./paths";
var ua = typeof navigator === "object" ? navigator.userAgent : undefined;

export const IS_MOBILE = /Android|webOS|iPhone|iPad|iPod/i.test(ua);
export const IS_STORYBOOK = false;
